module.exports = "../images/big-falls-trout-river.jpg?v=4cc2270";